<script>
import MacroCardMini from '@components/macros/macro-card-mini.vue';
import MealtimeDishesStack from '@components/recipe/mealtime-dishes-stack.vue';
import { homeComputed } from '@state/helpers';

export default {
  components: {
    MacroCardMini,
    MealtimeDishesStack,
  },
  props: {
    day: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...homeComputed,
    breakfastDishes() {
      const breakfast = this.homeOverview.todaysMeals.Breakfast;
      return breakfast.meals.concat(breakfast.recipes).concat(breakfast.leftovers);
    },
    lunchDishes() {
      const lunch = this.homeOverview.todaysMeals.Lunch;
      return lunch.meals.concat(lunch.recipes).concat(lunch.leftovers);
    },
    dinnerDishes() {
      const dinner = this.homeOverview.todaysMeals.Dinner;
      return dinner.meals.concat(dinner.recipes).concat(dinner.leftovers);
    },
    dailyMacros() {
      return this.homeOverview.todaysMeals;
    },
    hasMeals() {
      return (
        this.homeOverview &&
        this.homeOverview.todaysMeals &&
        this.homeOverview.todaysMeals.aggregatedNutritionDigest &&
        this.homeOverview.todaysMeals.aggregatedNutritionDigest.recipesWithNutrition
      );
    },
  },
  methods: {
    toNutrition() {
      this.$router.push({ name: 'nutrition' });
    },
  },
};
</script>

<template>
  <div class="card-daily-meals" @click="toNutrition">
    <b-row>
      <b-col md="12" sm="12">
        <div class="daily-meals-header">
          <h2>Today’s Meals</h2>
          <span @click="toNutrition">
            <BaseIcon class="icon-arrow" name="arrow-right" />
          </span>
        </div>
      </b-col>
      <template v-if="hasMeals">
        <b-col md="6" sm="6" lg="3">
          <MealtimeDishesStack title="Breakfast" :dishes="breakfastDishes" />
        </b-col>
        <b-col md="6" sm="6" lg="3">
          <MealtimeDishesStack title="Lunch" :dishes="lunchDishes" />
        </b-col>
        <b-col md="6" sm="6" lg="3">
          <MealtimeDishesStack title="Dinner" :dishes="dinnerDishes" />
        </b-col>
        <b-col md="6" sm="6" lg="3">
          <MacroCardMini :day="dailyMacros" :hideBorder="true" />
        </b-col>
      </template>
      <b-col v-else>
        <div class="no-results">
          <h3>No Meals Scheduled</h3>
          <p
            >It looks like you don't have any recipes in your plan yet. Grab a curated recipe plan to get started quickly. Or you
            can build your own.</p
          >
          <BaseButton type="button" class="button btn-secondary btn-round btn-add-more" @click="$router.push({ name: 'nutriton' })">
            <strong>Start Planning</strong>
          </BaseButton>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-daily-meals {
  background: white;
  border-radius: $base-border-radius-lg;
  box-shadow: $color-card-base-box-shadow;
  cursor: pointer;
  height: 100%;
  margin-bottom: 4rem;
  padding: 4.7rem 4rem 1.7rem;
  .daily-meals-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.8rem;

    h2 {
      margin-bottom: 0;
    }

    .icon-arrow {
      font-size: 1.7rem;

      &:hover {
        cursor: pointer;
      }
    }
  }
  .no-results {
    color: black;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 40%;
    @media screen and (max-width: 1300px) {
      width: 70%;
    }
    h3 {
      font-size: 24px;
      font-style: normal;
      font-weight: normal;
      line-height: 24px;
      margin-bottom: 10px;
    }
    p {
      font-size: 17px;
      font-style: normal;
      font-weight: normal;
      line-height: 17px;
      margin-bottom: 20px;
    }
    .btn-add-more {
      font-size: 1.75rem;
      padding: 2rem 3rem;
    }
  }
}
</style>
